import React from 'react';
import { motion } from 'framer-motion';
import { Star, UserIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Me despertaba a las 3 am todos los días. Ahora duermo de corrido y amanezco con energía real. Entender lo del cortisol cambió mis noches.',
  name: 'Laura M., 46 años — Ciudad de México 🇲🇽',
  image: 'https://cdn.magicpatterns.com/uploads/1QWprxTbst9DAwCgJDRT1S/Laura.webp'
}, {
  quote: 'El protocolo de vaciado mental cambió mis noches. Ya no doy vueltas en la cama pensando en todo lo que tengo que hacer al día siguiente.',
  name: 'Carmen R., 52 años — Guadalajara 🇲🇽',
  image: 'https://cdn.magicpatterns.com/uploads/5Gp9DpptPffXwXvHhfAVHU/carmen.webp'
}, {
  quote: 'Entender lo del magnesio y la temperatura hizo toda la diferencia. Por fin descanso profundamente y me levanto sintiéndome ligera.',
  name: 'Ana P., 41 años — Monterrey 🇲🇽',
  image: 'https://cdn.magicpatterns.com/uploads/ikrgDUnPvWS5d8BYRErB9F/ana.webp'
}, {
  quote: 'Pensé que el insomnio era normal por la edad. Aplicar esto me devolvió mis noches de descanso. No es magia, es entender tu cuerpo.',
  name: 'María L., 49 años — CDMX 🇲🇽',
  image: 'https://cdn.magicpatterns.com/uploads/mdXjwPfwk9HY54WGRVfZWm/Maria.webp'
}];
export function TestimonialsSection() {
  return <section className="bg-cream py-16 md:py-24 px-4" data-id="element-246">
      <div className="max-w-6xl mx-auto" data-id="element-247">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-248">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-olive mb-4" data-id="element-249">
            Lo que dicen las mujeres que decidieron aplicar esta metodología
          </h2>
          <p className="text-lg md:text-xl text-warm-gray" data-id="element-250">
            Ellas encontraron armonía, energía y ligereza. Tú también puedes.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-251">
          {testimonials.map((testimonial, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-card flex flex-col justify-between" data-id="element-252">
              <div data-id="element-253">
                <div className="flex gap-1 mb-6" data-id="element-254">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-warm-accent text-warm-accent" data-id="element-255" />)}
                </div>
                <p className="text-warm-gray text-lg italic mb-8 leading-relaxed" data-id="element-256">
                  "{testimonial.quote}"
                </p>
              </div>

              {/* Profile row with circular image placeholder */}
              <div className="flex items-center gap-3" data-id="element-257">
                <div className="w-12 h-12 rounded-full bg-sage/15 border-2 border-sage/30 flex-shrink-0 overflow-hidden flex items-center justify-center" data-id="element-258">
                  {testimonial.image ? <img src={testimonial.image} alt={testimonial.name} className="w-full h-full object-cover" data-id="element-259" /> : <UserIcon className="w-6 h-6 text-sage/50" data-id="element-260" />}
                </div>
                <p className="text-olive font-bold font-heading" data-id="element-261">
                  {testimonial.name}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}